export const teams_ChatAroundEmailButton = "aqvkt";
export const teams_ChatAroundEmailAllButton = "pbjhO";
export const teams_ChatAroundEmailSplitButton = "_Vi$kb";
export const teams_ShareToTeamsChatButton = "TJ1aSd";
export const copyToButton = "oEzwRb";
export const myDayButton = "O3kuid";
export const myDayMenuShow = "yURwte";
export const myDayMenuHide = "BbFiue";
export default {teams_ChatAroundEmailButton,teams_ChatAroundEmailAllButton,teams_ChatAroundEmailSplitButton,teams_ShareToTeamsChatButton,copyToButton,myDayButton,myDayMenuShow,myDayMenuHide};